export default __webpack_public_path__ + "static/media/img-6.46e5c3ac.jpg";